export enum OptionOrderStateEnum {
	OPEN = 'open',
	CANCELED = 'canceled',
	FILLED = 'filled',
}
